import { RequiredOptions, OptionalOptions } from "types/types";

/**
 * Fetch all possible options from HTML page window, and update options objects
 */
function setUpOptions(requiredOptions: RequiredOptions, optionalOptions: OptionalOptions) {
  // Required option
  if (typeof window.tableUrl === 'string' && window.tableUrl.length > 0) {
    requiredOptions._tableUrl = window.tableUrl;
  } else {
    throw new Error('Please provide a URL (variable name: tableUrl)');
  }
  
  // Optional options

  if (typeof window.columnsToFetch === 'string') {
    optionalOptions._columnsToFetch = window.columnsToFetch.toUpperCase().trim();
  }

  if (typeof window.initialRowsPerPage === 'number') {
    optionalOptions._initialRowsPerPage = window.initialRowsPerPage;
  }

  if (Array.isArray(window.rowsPerPageOptions) && window.rowsPerPageOptions.every(item => typeof item === 'number')) {
    optionalOptions._rowsPerPageOptions = window.rowsPerPageOptions;
  }

  if (typeof window.enableStickyHeader === 'boolean') {
    optionalOptions._enableStickyHeader = window.enableStickyHeader;
  }

  if (typeof window.enablePagination === 'boolean') {
    optionalOptions._enablePagination = window.enablePagination;
  }

  if (typeof window.enableFiltering === 'boolean') {
    optionalOptions._enableFiltering = window.enableFiltering;
  }

  if (typeof window.enableSorting === 'boolean') {
    optionalOptions._enableSorting = window.enableSorting;
  }
  
  if (typeof window.enableDensityToggle === 'boolean') {
    optionalOptions._enableDensityToggle = window.enableDensityToggle;
  }

  if (typeof window.enableFullScreenToggle === 'boolean') {
    optionalOptions._enableFullScreenToggle = window.enableFullScreenToggle;
  }
  
  if (typeof window.enableColumnHiding === 'boolean') {
    optionalOptions._enableColumnHiding = window.enableColumnHiding;
  }

  if (typeof window.enableSearch === 'boolean') {
    optionalOptions._enableSearch = window.enableSearch;
  }
  
  if (typeof window.filteringCombiner === 'string') {
    const option = window.filteringCombiner.toUpperCase().trim();
    if (option === 'OR' || option === 'AND') {
      optionalOptions._filteringCombiner = option;
    } else {
      console.warn('Invalid filtering combiner. Please use "OR" or "AND". Defaulting to "AND".');
    }
  }

  if (typeof window.initialDensity === 'string') {
    const option = window.initialDensity.toLowerCase().trim();
    if (option === 'compact' || option === 'comfortable' || option === 'spacious') {
      optionalOptions._initialDensity = option;
    } else {
      console.warn('Invalid initial density. Please use "compact", "comfortable" or "spacious". Defaulting to "comfortable".');
    }
  }

  if (typeof window.initialVisibleColumns === 'string') {
    optionalOptions._initialVisibleColumns = window.initialVisibleColumns.toUpperCase().trim();
  }

  if (typeof window.enableModalWindow === 'boolean') {
    optionalOptions._enableModalWindow = window.enableModalWindow;
  }
}

export function getTableOptions(): { requiredOptions: RequiredOptions; optionalOptions: OptionalOptions;} {
  // Needed from HTML
  const requiredOptions: RequiredOptions = {
    _tableUrl: '',
  };

  // Optional from HTML - default values set
  const optionalOptions: OptionalOptions = {
    _columnsToFetch: '',
    _initialRowsPerPage: 10,
    _rowsPerPageOptions: [5, 10, 20, 40],
    _enableStickyHeader: true,
    _enablePagination: true,
    _enableFiltering: true,
    _filteringCombiner: 'AND',
    _enableSorting: true,
    _enableDensityToggle: true,
    _initialDensity: 'comfortable',
    _enableFullScreenToggle: true,
    _enableColumnHiding: true,
    _enableSearch: true,
    _initialVisibleColumns: '',
    _enableModalWindow: true,
  };

  setUpOptions(requiredOptions, optionalOptions);

  return {
    requiredOptions,
    optionalOptions,
  };
}